// 스위치 변경 기록 모달 — 공고 관리 모달 위에 한 겹 더. 바깥 클릭 시 이 모달만 닫힘.
import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import styles from '../../componentsStyle/jobopening.module.css';
import { getFetch } from '../../../fetch/fetch';
import { SWITCHES } from './jobopeningconstants';

const logBoxStyle: any = {
    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    width: 'calc(100% - 48px)', maxWidth: 480, maxHeight: 'calc(100vh - 48px)', overflowY: 'auto',
    bgcolor: '#fff', borderRadius: '16px', boxShadow: 24, outline: 'none',
    p: '20px 22px 22px', display: 'flex', flexDirection: 'column', gap: '14px', boxSizing: 'border-box'
};

const DOW = ["일", "월", "화", "수", "목", "금", "토"];

// "2026-10-15 09:12" → "10/15 (목) 09:12"
const fmtAt = (s: string) => {
    const [d, t] = (s || "").split(" ");
    const [y, m, dd] = (d || "").split("-").map((x) => +x);
    if (!y) return s;
    return `${m}/${String(dd).padStart(2, "0")} (${DOW[new Date(y, m - 1, dd).getDay()]}) ${t || ""}`;
};

interface Props {
    row: any;
    branchLabel: string;
    onClose: () => void;
}

const JobOpeningLogModal: React.FC<Props> = ({ row, branchLabel, onClose }) => {

    const [state, setState] = useState<any>(null);
    const [logs, setLogs] = useState<any[]>([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const result: any = await getFetch(`/dashboard/jobopening/logs?id=${row.id}`);
                if (result.message === "success") {
                    setState(result.data.state);
                    setLogs(result.data.logs);
                }
            } catch (e) {
                console.log(e);
            }
            setLoaded(true);
        })();
    }, [row.id]);

    // 서버 값이 오기 전엔 표의 현재 값으로
    const cur = state || row;

    return (
        <Modal open onClose={onClose} sx={{ zIndex: 700 }}>
            <Box sx={logBoxStyle} className={styles.wrap} role="dialog" aria-label="변경 기록">
                <div className={styles.logHead}>
                    <div>
                        <div className={styles.logTitle}>스위치 변경 기록</div>
                        <div className={styles.logSub}><span className={styles.loc}>{branchLabel}</span> {row.partName}</div>
                    </div>
                    <button className={styles.iconBtn} aria-label="닫기" onClick={onClose}>
                        <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#333333" strokeWidth="2" strokeLinecap="round"><path d="M6 6l12 12M18 6L6 18"></path></svg>
                    </button>
                </div>

                <div className={styles.stateGrid}>
                    {SWITCHES.map((s) => (
                        +cur[s.key] ? (
                            <div key={s.key} className={styles.stateOn}><div>{s.label}</div><div className={styles.stateOnBadge}>ON</div></div>
                        ) : (
                            <div key={s.key} className={styles.stateOff}><div>{s.label}</div><div className={styles.stateOffBadge}>OFF</div></div>
                        )
                    ))}
                </div>

                <div>
                    <div className={styles.logListHead}>변경 기록 (최근순)</div>
                    {logs.map((it) => (
                        <div key={it.id} className={styles.logItem}>
                            <div className={styles.logLabel}>{(SWITCHES.find((s) => s.key === it.switchKey) || { label: it.switchKey }).label}</div>
                            {+it.isOn ? <div className={styles.logOn}>켬</div> : <div className={styles.logOff}>끔</div>}
                            <div className={styles.logAt}>{fmtAt(it.changedAt)}</div>
                            <div className={styles.logWho}>{it.changedByName}</div>
                        </div>
                    ))}
                    {loaded && logs.length === 0 ? <div className={styles.logEmpty}>아직 바뀐 적이 없습니다.</div> : null}
                </div>
            </Box>
        </Modal>
    );
};

export default JobOpeningLogModal;
